/**
 * DemoTag — Subtiles Wasserzeichen-Badge fuer Demo-Modus (W3.1)
 *
 * Kleines "[Demo]"-Tag fuer Dashboard-Karten und Sektionen.
 * Nur sichtbar wenn Demo-Modus aktiv.
 */
import { useTranslation } from 'react-i18next'
import { isDemoMode } from '../services/demoMode'

interface DemoTagProps {
  style?: React.CSSProperties
}

export function DemoTag({ style }: DemoTagProps) {
  const { t } = useTranslation('components')

  if (!isDemoMode()) return null

  return (
    <span
      data-testid="demo-tag"
      aria-label={t('demoTag.ariaLabel')}
      style={{
        display: 'inline-block',
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: '0.04em',
        color: 'var(--accent, #6366f1)',
        background: 'color-mix(in srgb, var(--accent, #6366f1) 12%, transparent)',
        border: '1px solid color-mix(in srgb, var(--accent, #6366f1) 30%, transparent)',
        borderRadius: 4,
        padding: '1px 5px',
        lineHeight: '16px',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      {t('demoTag.label')}
    </span>
  )
}
